<script>
import ListingModel from "@/views/Evaluation/FileModel/Components/ListingModel.vue";

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel type="EVALUATION_PERFORMANCE"/>
</template>